export default {
  chapterXML: `<data>
  <scripts>
    <scene id="1" title="餐厅剧情" root="true">
      <bgm id="舒缓叙事"></bgm>
      <bg img="吼姆餐厅前"></bg>
      <text>WHOAH! A red-haired beauty named Himeko18 just friended me on Firebox!</text>
      <text>She asked to meet me for dinner at HOMU-Burger near my place!</text>
      <text>I arrived at the fast food restaurant, but can this be a stupid prank?</text>
      <motion chara="姬子" action="show" img="姬子3" pos="right"></motion>
      <text>Hold on, I think I saw a really nice looking [em bold]red-haired girl[/em] in the place.</text>
      <text>Hmm... it might not be her...</text>
      <motion chara="八重樱" action="show" pos="left" img="八重櫻6"></motion>
      <text>Wait, there's a pink-haired girl as well.</text>
      <text>Crap, I gotta choose one of them.</text>
      <event action="goto" to="16"></event>
    </scene>
    <scene id="2" prev="16" title="死亡劇情">
      <bgm id="死亡+公园"></bgm>
      <bg img="吼姆餐厅前"></bg>
      <motion chara="姬子" action="show" pos="right" img="姬子5"></motion>
      <text>I guess you need a taste of Surtr, the Godsbane Greatsword.</text>
      <motion chara="姬子" action="hide"></motion>
      <text>NOOOOO! You're gonna wreck the place!</text>
      <event action="callback" name="dead" val="16"></event>
    </scene>
    <scene id="3" prev="16" title="進入餐廳">
      <bgm id="欢快"></bgm>
      <bg img="吼姆快餐店"></bg>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <dialog chara="姬子">Hi. And you are...</dialog>
      <dialog chara="我">Oh, are you the one on Firebox?</dialog>
      <motion chara="姬子" action="hide"></motion>
      <motion chara="姬子" action="show" pos="right" img="姬子6"></motion>
      <dialog chara="姬子">Indeed. Turned out your profile photo is pretty honest. My name is actually Himeko, by the way.</dialog>
      <motion chara="姬子" action="hide"></motion>
      <dialog chara="我">Hi. I also used my real name on my Firebox account.</dialog>
      <dialog chara="我">The Dinner for Two is a really awesome deal.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子8"></motion>
      <dialog chara="姬子">Nah. I'll just have two HOMU Super Burgers. No fries, no soda. Ice water is fine.</dialog>
      <dialog chara="我">Alright. I like carbs. I'll go for a cheeseburger, some spaghetti, and a HOMU Bitter Melon Juice.</dialog>
      <text>I'll just pay for the order.</text>
      <dialog chara="姬子">Hold on. I'll transfer the money for those 2 HOMU Supers to you.</dialog>
      <options>
        <option id="0" to="4">Don't worry about that. Just treat me next time.</option>
      </options>
    </scene>
    <scene id="4" type="block" prev="3" title="偶遇琪亞娜">
      <bgm id="欢快"></bgm>
      <bg img="吼姆快餐店"></bg>
      <motion chara="姬子" action="show" pos="right" img="姬子8"></motion>
      <dialog chara="姬子">Such confidence! Do you think there's a next time?</dialog>
      <dialog chara="我">Of course there will be a next time. To tell you the truth, I'm super relaxed right now.</dialog>
      <motion chara="姬子" action="hide"></motion>
      <motion chara="姬子" action="show" pos="right" img="姬子1"></motion>
      <dialog chara="姬子">Really? Because you look like someone who brushed by the gates of death a few times. Do you have a story to tell?</dialog>
      <dialog chara="我">Stories? Yeah, I have a few.</dialog>
      <dialog chara="我">I'm recently reading Beowulf and Undine.</dialog>
      <dialog chara="姬子">Old English and fairy tales? I never expected you to be interested in that.</dialog>
      <dialog chara="我">Whoah. I think I just found a friend to talk about it with.</dialog>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜5"></motion>
      <motion chara="姬子" action="hide"></motion>
      <dialog chara="琪亞娜">Help! Who ordered some pasta, three burgers, and some terrible bitter melon juice?</dialog>
      <dialog chara="我">I think that's our order.</dialog>
      <dialog chara="我">That bitter melon juice is really, really bitter.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子1"></motion>
      <dialog chara="姬子">So why would you order that?</dialog>
      <dialog chara="我">Because no one else does. I use it to identify my order.</dialog>
      <motion chara="姬子" action="hide"></motion>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜3"></motion>
      <dialog chara="琪亞娜">Here you go, fellas... WHOAH!</dialog>
      <dialog chara="我">My goodness! The waitress splashed the green juice all over Himeko!</dialog>
      <dialog chara="琪亞娜">...</dialog>
      <event action="goto" to="17"></event>
    </scene>
    <scene id="5" prev="17" title="琪亞娜被責怪">
      <bgm id="死亡+公园"></bgm>
      <bg img="吼姆快餐店"></bg>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜5"></motion>
      <dialog chara="我">Sheesh! Can you even do your job properly? Why would they hire someone clumsy like you? You gotta pay for this.</dialog>
      <dialog chara="琪亞娜">I... I've no money...</dialog>
      <dialog chara="我">Get your manager. I'm launching a complaint.</dialog>
      <dialog chara="琪亞娜">WHOAH! Please... I must keep this job!</dialog>
      <motion action="show" pos="right" img="姬子5" chara="姬子"></motion>
      <dialog chara="姬子">It's alright. I'm not wearing expensive stuff anyway.</dialog>
      <dialog chara="我">That's so ridiculous. I'm sorry.</dialog>
      <dialog chara="姬子">Well, you can be nicer about that, you know.</dialog>
      <mono>
        <p>You tried to restart the conversation, but it felt increasingly awkward. The date ended coldly.</p>
        <p></p>
        <p>You started playing Honkai Gods after getting home.</p>
        <p></p>
        <p>A player named Alloy_Bron seemed to have you in the sights.</p>
        <p></p>
        <p>After dying a few dozen times, you realized that Honkai Gods is no longer habitable.</p>
        <p></p>
        <p>The world is a cruel place. Perhaps it is the Purgatory where we must suffer until our sins are cleansed.</p>
        <p></p>
        <p>Restart?</p>
      </mono>
      <event action="callback" name="dead" val="17"></event>
    </scene>
    <scene id="6" prev="17" title="關心琪亞娜">
      <bgm id="死亡+公园"></bgm>
      <bg img="吼姆快餐店"></bg>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜5"></motion>
      <dialog chara="我">Are you alright? Let me help you up.</dialog>
      <motion chara="琪亞娜" action="hide"></motion>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜7"></motion>
      <dialog chara="琪亞娜">Thank you so much. You're such a nice person.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子7"></motion>
      <dialog chara="姬子">Excuse me. I'm the one getting soaked in your bitter melon drink.</dialog>
      <dialog chara="姬子">But you're paying more attention to this clumsy waitress.</dialog>
      <dialog chara="姬子">Care to tell me what's going on here?</dialog>
      <mono>
        <p>You tried to explain, but the red-haired dame only gave you a silent, steely gaze.</p>
        <p></p>
        <p>You quickly ran out of words. Bystanders shook their heads and left.</p>
        <p></p>
        <p>They know what's in store for you.</p>
      </mono>
      <event action="callback" name="dead" val="17"></event>
    </scene>
    <scene id="7" prev="17" title="安撫姬子">
      <bgm id="舒缓叙事"></bgm>
      <bg img="吼姆快餐店"></bg>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜7"></motion>
      <dialog chara="琪亞娜">Oh dear, I'm sorry... I'm so sorry. I'll get some towels right now.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子5"></motion>
      <dialog chara="姬子">These poor girls need more training. Fortunately I'm just wearing my casual uniform.</dialog>
      <dialog chara="我">I think the owner is offering part-time opportunities to these kids.</dialog>
      <motion chara="姬子" action="hide"></motion>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <dialog chara="姬子">You acted pretty quickly. That girl didn't even know what to do.</dialog>
      <motion chara="琪亞娜" action="hide"></motion>
      <motion chara="琪亞娜"></motion>
      <dialog chara="琪亞娜">Towels! Here you go! I'm really sorry about that. Whoops, I think I gotta go.</dialog>
      <motion chara="琪亞娜" action="hide"></motion>
      <dialog chara="我">Whoah. She gave us 10 towels.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子1"></motion>
      <dialog chara="姬子">Hah. I guess she over-reacted and wanted to make it up to us.</dialog>
      <dialog chara="姬子">I'm really starving, by the way. These burgers look great.</dialog>
      <dialog chara="我">Bon Appetit！</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子6"></motion>
      <dialog chara="姬子">That's an awesome meal. Do you want to go anywhere?</dialog>
      <dialog chara="我">Well...</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子1"></motion>
      <dialog chara="姬子">Your cellphone casing seems to be some merch from a famous video game.</dialog>
      <dialog chara="我">Oh yeah. Honkai Gods. It has topped the charts for several years.</dialog>
      <dialog chara="我">They have a super-realistic world and...</dialog>
      <dialog chara="姬子">And what?</dialog>
      <dialog chara="我">Well... a lot of other things, but you sure you wanna talk about video games?</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子5"></motion>
      <dialog chara="姬子">My students ... ahem... I mean I have friends who play games.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子8"></motion>
      <dialog chara="姬子">Let's head to the arcade. It's more fun when you're playing against an actual person.</dialog>
      <dialog chara="姬子">Excuse me, are you alright?</dialog>
      <dialog chara="我">Ah, I'm just recovering from shock.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <dialog chara="姬子">Don't be. I think there are plenty of surprises in store for us. Let's head to HOLA Arcade right now.</dialog>
      <event action="goto" to="8"></event>
    </scene>
    <scene id="8" prev="7" title="吼姆遊戲廳">
      <bgm id="游戏厅"></bgm>
      <bg img="游戏中心"></bg>
      <text>We arrived at the biggest arcade in the city.</text>
      <motion chara="姬子" action="show" pos="right" img="姬子4"></motion>
      <text>Whoo-hoo. We have several dozen Queen of Valkyrja II machines here.</text>
      <dialog chara="我">It's *the* most hardcore fighting game on the market.</dialog>
      <dialog chara="我">There's dozens of Valkyries and battlesuits... and god-knows how many moves and combos...</dialog>
      <dialog chara="我">Wait, isn't that silver-haired girl the HOMU-Burger waitress? Why is she here?</dialog>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜4"></motion>
      <dialog chara="琪亞娜">AMAGAD! They found me! Evasion time!</dialog>
      <motion chara="琪亞娜" action="hide"></motion>
      <motion chara="姬子" action="show" pos="right" img="姬子8"></motion>
      <dialog chara="姬子">Uhm... I guess we have a machine available right now. I'll challenge you with the Valkyrie that looks like me. How about you?</dialog>
      <dialog chara="我">My goodness! She's like... a direct copy of you! Are you modeling for this game?</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子1"></motion>
      <dialog chara="姬子">Hah. I wish I did, but no I didn't.</dialog>
      <bgm id="战斗2"></bgm>
      <dialog chara="姬子">Done choosing? Let's start.</dialog>
      <dialog chara="我">She's not very good at Queen of Valkyrja II, but it was clear she played it quite a few times.</dialog>
      <dialog chara="我">I deliberately gave her a few attack opportunities and allowed her to win a few fights.</dialog>
      <dialog chara="我">It's hard for me to come to terms that such a beautiful lady plays video games.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子7"></motion>
      <dialog chara="姬子">TAKE THAT! TAKE THAT, YOU SUCKER! HOW DOES THAT FEEL? WATCH ME RIP YOU APART! HAHAHAHAHA *snort*!</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <dialog chara="我">It's obvious that she has special feelings for a particular character.</dialog>
      <dialog chara="我">Especially that special anniversary edition Void Queen.</dialog>
      <dialog chara="姬子">Phewie. Let's be honest. Are you letting me win on purpose?</dialog>
      <dialog chara="我">Uhm... yeah... I wanted to make you happy.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子1"></motion>
      <dialog chara="姬子">I thought so. I usually can't win fighting games like this.</dialog>
      <dialog chara="姬子">I don't know many moves. I simply mash the attack button and cast the Ultimate when I can.</dialog>
      <motion chara="芽衣" action="show" pos="left" img="芽衣2"></motion>
      <dialog chara="芽衣">HELP! I can't even beat the machine on SUPER EASY! How do you cast the Ultimate?</dialog>
      <motion action="hide" chara="姬子"></motion>
      <motion action="show" pos="right" img="姬子4" chara="姬子"></motion>
      <dialog chara="姬子">My goodness! Hey, do you want to help her out a little?</dialog>
      <dialog>Okay. Here, just watch that yellow bar. Press these buttons at the same time when it's maxed.</dialog>
      <motion chara="芽衣" action="show" pos="left" img="芽衣6"></motion>
      <dialog chara="芽衣">DRAGON MAY CRY! My goodness! I only seen this Ultimate once before!</dialog>
      <dialog chara="芽衣">I won! I'm so happy!</dialog>
      <motion action="show" pos="right" img="姬子1" chara="姬子"></motion>
      <dialog chara="姬子">You're really good at talking to girls, you know that?</dialog>
      <dialog chara="我">We're all gamers. There are no national, age, or gender barriers between us.</dialog>
      <motion chara="芽衣" action="hide"></motion>
      <motion chara="符華" action="show" pos="left" img="符華5"></motion>
      <dialog chara="符華">Well put. I wonder if I can challenge you to a fight, warrior.</dialog>
      <bgm id="战斗"></bgm>
      <dialog chara="我">The new challenger emitted a powerful aura of a serious gamer.</dialog>
      <dialog chara="我">In fact, her aura is pretty... intimidating.</dialog>
      <dialog chara="姬子">Watch out, dear. Don't lose.</dialog>
      <motion chara="姬子" action="hide"></motion>
      <motion chara="符華" action="show" pos="right" img="符華1"></motion>
      <dialog chara="符華">I'll use Shadow Knight, Accipiter, and Phoenix.</dialog>
      <event action="goto" to="18"></event>
    </scene>
    <scene id="9" prev="18" title="銀髮律者">
      <bgm id="死亡+公园"></bgm>
      <bg img="游戏中心"></bg>
      <motion chara="姬子" action="show" pos="right" img="姬子5"></motion>
      <dialog chara="姬子">Why do you keep using the Void Queen?</dialog>
      <motion chara="符華" action="show" pos="left" img="符華1"></motion>
      <dialog chara="符華">Well, she does have the highest DPS of all the characters.</dialog>
      <dialog chara="符華">Allow me defeat her.</dialog>
      <dialog chara="符華">TAKE THAT! TAKE THAT, YOU SUCKER! HOW DOES THAT FEEL? WATCH ME POUND YOU TO DUST! HAHAHAHAHA *snort*!</dialog>
      <motion chara="符華" action="show" pos="left" img="符華6"></motion>
      <dialog chara="符華">Sorry... I think I got carried away. Are you alright?</dialog>
      <dialog chara="姬子">I... I think we should call an ambulance.</dialog>
      <event action="callback" name="dead" val="18"></event>
    </scene>
    <scene id="10" prev="18" title="世界第一可愛大隊">
      <bgm id="死亡+公园"></bgm>
      <bg img="游戏中心"></bg>
      <motion chara="姬子" action="show" pos="right" img="姬子5"></motion>
      <dialog chara="姬子">These girls look underaged. You sure about this?</dialog>
      <dialog chara="我">You should check out the lore. She may look like a young girl...</dialog>
      <dialog chara="我">...but she's really a genetically engineered clone soldier made by a mysterious organization.</dialog>
      <dialog chara="我">She's really strong. Let the fight begin.</dialog>
      <motion chara="符華" action="show" pos="left" img="符華6"></motion>
      <dialog chara="符華">ORARARARARARA！</dialog>
      <motion chara="符華" action="hide"></motion>
      <dialog chara="我">WHOAH! My opponent's mashing the controls at hyper speed! The joystick is on fire!</dialog>
      <text>BOOM</text>
      <dialog chara="我">Sorry... I think I got carried away. Are you alright?</dialog>
      <dialog chara="姬子">I... I think we should call an ambulance.</dialog>
      <event action="callback" name="dead" val="18"></event>
    </scene>
    <scene id="11" type="block" prev="18" title="真紅騎士套">
      <bgm id="游戏厅"></bgm>
      <bg img="游戏中心"></bg>
      <dialog chara="我">I gotta admit, there are some really pro players in the arcade.</dialog>
      <dialog chara="我">My challenger's fluid controls, perfect tempo, and the way she sits reveal a dreadful truth.</dialog>
      <dialog chara="我">She must be FURIA_WHALEKILLER, one of the top players of the game.</dialog>
      <dialog chara="我">I... I lost.</dialog>
      <motion chara="符華" action="show" pos="left" img="符華5"></motion>
      <dialog chara="符華">You fought till the very end.</dialog>
      <dialog chara="符華">You even managed to hit me once.</dialog>
      <dialog chara="符華">You have potential, but you need to time your dodges and attacks better.</dialog>
      <dialog chara="符華">The battlefield always changes. Stay vigilant at all times.</dialog>
      <dialog chara="我">I think I learned something very important.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <dialog chara="姬子">Fu Hua is indeed my best stude... I mean, I think that pro-gamer enjoyed the fight.</dialog>
      <dialog chara="我">Hey, the pro-gamer is chatting with the girl who doesn't know any moves at all...</dialog>
      <text>And they left the place in a hurry.</text>
      <motion chara="姬子" action="show" pos="right" img="姬子6"></motion>
      <dialog chara="姬子">They look like students. I think they're preparing for some exam.</dialog>
      <dialog chara="姬子">Ooh. It's getting late. Let's get some snacks and drinks from a store and take a walk in the park.</dialog>
      <dialog chara="我">Sounds like a plan.</dialog>
      <event action="goto" to="12"></event>
    </scene>
    <scene id="12" prev="11" title="公園">
      <bgm id="舒缓叙事"></bgm>
      <bg img="公園1"></bg>
      <dialog chara="我">This date turned out to be much more than I expected.</dialog>
      <dialog chara="我">We had a great meal, played games at the arcade, and now we're walking in the park.</dialog>
      <dialog chara="我">Why is this red-haired lady so into me?</dialog>
      <dialog chara="我">I glanced at her to admire her beauty. She sipped her drink elegantly under the blooming cherry tree and basked in the moonlight.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子6"></motion>
      <dialog chara="姬子">HAHAHAHAHA! Bottoms up, twerp! WHAT?! You're not drinking? You chicken. Watch me empty this can. GLUG GLUG GLUG.</dialog>
      <motion chara="德麗莎" action="show" pos="left" img="德麗莎3"></motion>
      <dialog chara="我">Oh dear. You got the drink all over yourself. Here's some tissue.</dialog>
      <motion chara="德麗莎" action="hide"></motion>
      <motion chara="麗塔" action="show" pos="left" img="麗塔1"></motion>
      <dialog chara="麗塔">Don't get too close to those two, young mistress. Only losers drink themselves silly in public.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子7"></motion>
      <dialog chara="姬子">HEY! Are you talking about me? You need to be given a world of hurt. Get over here, you silly maid!</dialog>
      <motion chara="麗塔" action="show" pos="left" img="麗塔7"></motion>
      <dialog chara="麗塔">Oh my heart... (falls to the ground slowly)</dialog>
      <motion chara="麗塔" action="hide"></motion>
      <motion chara="德麗莎" action="show" pos="left" img="德麗莎8"></motion>
      <dialog chara="德麗莎">KYAAA! KYAAA! Rita, are you alright?</dialog>
      <dialog chara="麗塔">…</dialog>
      <dialog chara="姬子">Oh dear, I didn't expect her to pass out like that. What should we do?</dialog>
      <event action="goto" to="19"></event>
    </scene>
    <scene id="13" prev="19" title="人工呼吸">
      <bgm id="死亡+公园"></bgm>
      <bg img="公園1"></bg>
      <motion chara="德麗莎" action="show" pos="left" img="德麗莎8"></motion>
      <dialog chara="德麗莎">AMAGAD! What are you doing?</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子7"></motion>
      <dialog chara="姬子">AMAGAD! What are you doing?</dialog>
      <dialog chara="我">I'm giving her CPR.</dialog>
      <dialog chara="姬子">That doesn't make sense. This silly maid is still breathing. I think you're just taking advantage of this poor lady.</dialog>
      <dialog chara="姬子">You're a terrible person.</dialog>
      <dialog chara="姬子">I must purge this world of your existence.</dialog>
      <event action="callback" name="dead" val="19"></event>
    </scene>
    <scene id="14" type="block" prev="19" title="麗塔後主線">
      <bgm id="舒缓叙事"></bgm>
      <bg img="公園1"></bg>
      <text>Why would a maid and a little girl walk in a park so late at night? It doesn't feel right.</text>
      <text>People usually try to avoid talking to drunks anyway.</text>
      <motion chara="姬子" action="show" pos="right" img="姬子7"></motion>
      <dialog chara="姬子">Drunks? Who are you talking about?</dialog>
      <dialog chara="我">Most people won't faint when they see a red-haired beauty.</dialog>
      <dialog chara="我">And the way she fell to the ground... it was slow and awkward... as if she's trying to avoid scratching herself.</dialog>
      <dialog chara="我">That maid must have faked it.</dialog>
      <dialog chara="姬子">HEARD THAT, YOU FAKERS? GET OUT OF MY SIGHT!</dialog>
      <motion chara="德麗莎" action="show" pos="left" img="德麗莎8"></motion>
      <dialog chara="德麗莎">KYAAA! She's so scary! Rita, let's get out of here.</dialog>
      <motion chara="德麗莎" action="hide"></motion>
      <motion chara="麗塔" action="show" pos="left" img="麗塔7"></motion>
      <dialog chara="麗塔">Oh dear. I think my bad acting spoiled it again.</dialog>
      <motion chara="麗塔" action="hide"></motion>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <dialog chara="姬子">Go on, run like the lame maid you are.</dialog>
      <dialog chara="姬子">This date turned out pretty informative for me.</dialog>
      <dialog chara="姬子">You're a great person. You've plenty of potential.</dialog>
      <dialog chara="我">Potential?</dialog>
      <dialog chara="姬子">Yeah. You know your stuff, you're good at observing people, and you have fast reflexes.</dialog>
      <dialog chara="姬子">Most importantly, you're willing to help others, but you're also on your guard. That's pretty impressive.</dialog>
      <dialog chara="姬子">The world is a dangerous place. We need more people like you.</dialog>
      <dialog chara="我">This isn't an ordinary Firebox date, right?</dialog>
      <motion chara="姬子" action="show" pos="left" img="姬子8"></motion>
      <dialog chara="姬子">BINGO. It's not.</dialog>
      <dialog chara="姬子">I've been watching you for a while.</dialog>
      <dialog chara="姬子">I was hoping that this date will take us till the very end.</dialog>
      <dialog chara="姬子">But one day ain't enough, and the hour runs late.</dialog>
      <dialog chara="我">Yeah. I gotta say that it was a wonderful evening.</dialog>
      <dialog chara="我">But it's the weekend tomorrow. We can chat till morning if you...</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子6"></motion>
      <dialog chara="姬子">Chat till morning in the park? Come on.</dialog>
      <dialog chara="姬子">It was a *very* enjoyable evening, but I must head home and catch some sleep.</dialog>
      <dialog chara="我">I think we're onto something wonderful.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子1"></motion>
      <dialog chara="姬子">You are one sweet talker, you know that? But I really have to go.</dialog>
      <text>An expensive looking minibus stopped at the road near us.</text>
      <text>The door opened. The driver waved at Himeko.</text>
      <dialog chara="姬子">That's my ride.</dialog>
      <dialog chara="姬子">I hate to let you go home alone, but I gotta follow protocol, you know.</dialog>
      <dialog chara="我">I understand. I really hope we can go out like this again.</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子6"></motion>
      <dialog chara="姬子">Don't be silly. You've made it this far already. There will be future opportunities.</dialog>
      <text>She quickly pecked my cheek...</text>
      <motion chara="姬子" action="hide"></motion>
      <text>...and got on the bus without turning around.</text>
      <text>The minibus driver tapped the horn before driving away.</text>
      <text>While heading home, I took out my cell and checked my Firebox account.</text>
      <text>Oh dear...</text>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <text>Himeko18 deleted her account. I couldn't contact her anymore.</text>
      <motion chara="姬子" action="hide"></motion>
      <text>It felt like a dream. An incredible dream.</text>
      <text>Perhaps I was actually dreaming.</text>
      <text>I wasted my entire Saturday staring at my ceiling and only started Honkai Gods after sunset.</text>
      <bgm id="舰桥"></bgm>
      <text>Perhaps Honkai Gods is where I truly belong.</text>
      <motion chara="合金布狼牙" action="show" pos="left" img="布洛妮婭1"></motion>
      <text>Whoah. I have a new friend... Alloy_Bron?! A Tier 99 Supreme Maestro?!</text>
      <dialog chara="合金布狼牙">Are you ready, player?</dialog>
      <dialog chara="我">Am I ready? Ready for what?</dialog>
      <dialog chara="合金布狼牙">You have bested Miss Himeko's trials.</dialog>
      <dialog chara="我">Miss Himeko? I've seen how Himeko play games. She's definitely not a Tier 99 Supreme Maestro in Honkai Gods.</dialog>
      <bg img="米哈遊大樓"></bg>
      <dialog chara="合金布狼牙">Subject Player has 195 minutes. Gather all your personal belongings and head to the rooftop of miHoYo Building.</dialog>
      <dialog chara="合金布狼牙">Subject Player is not too far from miHoYo Building. Be punctual.</dialog>
      <event action="goto" to="15"></event>
    </scene>
    <scene id="15" prev="14" title="大樓樓頂">
      <bg img="樓頂天台"></bg>
      <text>I didn't remember most of the details.</text>
      <text>I stuffed all my valuables into a backpack and went straight to the appointed location.</text>
      <text>And something astonishing happened when the time was up.</text>
      <bg img="休伯利安號"></bg>
      <text>The aerial battleship Hyperion descended from the skies. Bright searchlight beams forced me to cover my eyes.</text>
      <text>I suddenly remembered the Captain's Application Form I filled out in Honkai Gods.</text>
      <text>I thought it was an in-game event or a lame joke... I never expected this to happen...</text>
      <text>The cabin doors opened. A familiar red-haired lady appeared.</text>
      <text>She's flanked by a squad of beautiful girls who looked oddly familiar as well.</text>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <dialog chara="姬子">You ready, Captain?</dialog>
      <motion chara="姬子" action="hide"></motion>
      <motion chara="琪亞娜" action="show" pos="left" img="琪亞娜3"></motion>
      <dialog chara="琪亞娜">NEKO NEKO! I'm the bestest waitress there is, right? I'm best in everything!</dialog>
      <motion chara="琪亞娜" action="hide"></motion>
      <motion chara="符華" action="show" pos="right" img="符華5"></motion>
      <dialog chara="符華">The search for martial perfection is a never-ending quest.</dialog>
      <motion chara="符華" action="hide"></motion>
      <motion chara="芽衣" action="show" pos="left" img="芽衣2"></motion>
      <dialog chara="芽衣">Captain, I really suck at gaming. Can you teach me how to play better? I can teach you how to cook!</dialog>
      <motion chara="芽衣" action="hide"></motion>
      <motion chara="合金布狼牙" action="show" pos="right" img="布洛妮婭1"></motion>
      <dialog chara="合金布狼牙">The Bronya is Alloy_Bron, subject Captain.</dialog>
      <motion action="hide" chara="合金布狼牙"></motion>
      <motion chara="德麗莎" action="show" pos="left" img="德麗莎5"></motion>
      <dialog chara="德麗莎">I'm the Principal of St. Freya High and the World's No.1 Cutie! You're under my command, Captain!</dialog>
      <motion chara="德麗莎" action="hide"></motion>
      <motion chara="麗塔" action="show" pos="right" img="麗塔1"></motion>
      <dialog chara="麗塔">Fufufu. Your cabin is ready, Captain-sama. Do you want Moroccan Mint or Earl Grey for tea?</dialog>
      <motion chara="麗塔" action="hide"></motion>
      <motion chara="姬子" action="show" pos="left" img="姬子8"></motion>
      <dialog chara="姬子">The Honkai is corrupting the entire world, Captain. We need someone to lead us against them.</dialog>
      <dialog chara="姬子">Stop thinking about it. You're the best one there is.</dialog>
      <dialog chara="姬子">The entire world's waiting for you.</dialog>
      <motion chara="姬子" action="hide"></motion>
      <text>She pulled me on-board the Hyperion before I could say "yes".</text>
      <dialog chara="大家">Lead us in the Honkai War, Captain!</dialog>
      <motion chara="姬子" action="show" pos="right" img="姬子6"></motion>
      <dialog chara="姬子">Don't forget, Captain. I only kiss mature and responsible people.</dialog>
      <event action="callback" name="finish"></event>
    </scene>
    <scene id="16" type="block" prev="1" title="選項1">
      <bgm id="舒缓叙事"></bgm>
      <bg img="吼姆餐厅前"></bg>
      <motion chara="八重樱" action="show" pos="left" img="八重櫻6"></motion>
      <motion chara="姬子" action="show" pos="right" img="姬子3"></motion>
      <text>Crap, I gotta choose one of them.</text>
      <options>
        <option id="0" to="2">Talk to the pink-haired bunny girl?</option>
        <option id="1" to="3">It should be that super beautiful lady.</option>
      </options>
    </scene>
    <scene id="17" type="block" prev="4" title="選項2">
      <options>
        <option id="0" to="5">Reprimand the waitress</option>
        <option id="1" to="6">Comfort the cute waitress.</option>
        <option id="2" to="7">Have the waitress get some towels.</option>
      </options>
    </scene>
    <scene id="18" type="block" prev="8" title="選項3">
      <options>
        <option id="0" to="9">I'll solo with the Void Queen.</option>
        <option id="1" to="10">I'll use Team Cuteness Overload!</option>
        <option id="2" to="11">I'll use Vermilion Knight!</option>
      </options>
    </scene>
    <scene id="19" type="block" prev="12" title="選項4">
      <options>
        <option id="0" to="13">Give the beautiful maid some CPR.</option>
        <option id="1" to="14">Something's not right. I gotta stay vigilant.</option>
      </options>
    </scene>
  </scripts>
</data>`,
  resourceXML: `<data>
  <resource>
    <bg id="吼姆餐厅前" type="bg" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619273777077.jpg"></bg>
    <chara type="chara" id="八重櫻6" rel="八重樱" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714204734897.png"></chara>
    <chara id="姬子3" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714205349380.png" type="chara" rel="姬子"></chara>
    <chara id="姬子5" rel="姬子" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714205922699.png"></chara>
    <bg type="bg" id="吼姆快餐店" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619284622707.jpg"></bg>
    <chara src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714210543258.png" id="姬子6" type="chara" rel="姬子"></chara>
    <chara id="姬子8" rel="姬子" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714211194850.png"></chara>
    <chara id="姬子4" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714211653004.png" rel="姬子"></chara>
    <chara id="琪亞娜5" rel="琪亞娜" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714212441620.png"></chara>
    <chara id="姬子1" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714213068216.png" rel="姬子"></chara>
    <chara id="琪亞娜3" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714213581225.png" rel="琪亞娜"></chara>
    <chara src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714214088150.png" id="琪亞娜7" rel="琪亞娜"></chara>
    <chara id="姬子7" rel="姬子" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714214762500.png"></chara>
    <bg type="bg" id="廚房春節" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619285179813.jpg"></bg>
    <chara id="琪亞娜8" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714215971956.png" rel="琪亞娜"></chara>
    <bg type="bg" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619290298660.jpg" id="游戏中心"></bg>
    <chara id="琪亞娜4" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714220410143.png" type="chara" rel="琪亞娜"></chara>
    <chara id="芽衣2" rel="芽衣" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714221081305.png"></chara>
    <chara id="芽衣6" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714221764059.png" rel="芽衣"></chara>
    <chara id="符華5" rel="符華" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714222513381.png"></chara>
    <chara rel="符華" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714230952829.png" id="符華1"></chara>
    <chara id="符華6" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714231745067.png" rel="符華"></chara>
    <chara type="chara" id="麗塔1" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714232518478.png" rel="麗塔"></chara>
    <chara id="麗塔7" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714232914743.png" rel="麗塔"></chara>
    <chara id="德麗莎8" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714233928582.png" rel="德麗莎"></chara>
    <chara id="德麗莎3" rel="德麗莎" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714234628181.png"></chara>
    <chara id="布洛妮婭1" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714235260851.png" rel="合金布狼牙"></chara>
    <bg type="bg" id="米哈遊大樓" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619314463533.jpg"></bg>
    <bg id="樓頂天台" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619314981158.jpg"></bg>
    <bg id="休伯利安號" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619315893809.jpg"></bg>
    <chara type="chara" src="https://uploadstatic.mihoyo.com/contentweb/20190717/2019071714235729104.png" id="德麗莎5" rel="德麗莎"></chara>
    <bg id="公園1" type="bg" src="https://uploadstatic.mihoyo.com/contentweb/20190716/2019071619320238070.jpg"></bg>
    <bgm type="bgm" src="https://uploadstatic.mihoyo.com/contentweb/20190715/2019071510393348295.mp3" id="舒缓叙事"></bgm>
    <bgm id="死亡+公园" src="https://uploadstatic.mihoyo.com/contentweb/20190715/2019071510413531686.mp3"></bgm>
    <bgm id="欢快" src="https://uploadstatic.mihoyo.com/contentweb/20190715/2019071511225098741.mp3"></bgm>
    <bgm id="游戏厅" src="https://uploadstatic.mihoyo.com/contentweb/20190715/2019071510482198241.mp3"></bgm>
    <bgm id="战斗" src="https://uploadstatic.mihoyo.com/contentweb/20190715/2019071510501316578.mp3"></bgm>
    <bgm id="战斗2" src="https://uploadstatic.mihoyo.com/contentweb/20190715/2019071510543996092.mp3"></bgm>
    <bgm id="舰桥" src="https://uploadstatic.mihoyo.com/contentweb/20190715/2019071510561168242.mp3"></bgm>
  </resource>
  <characters>
    <c id="-1" name="Player"></c>
    <c id="-2" name="text"></c>
    <c id="-3" name="text"></c>
    <c id="姬子" name="Himeko18"></c>
    <c id="八重樱" name="Pink Bunny/Donkey (?)"></c>
    <c id="我" name="Player"></c>
    <c id="琪亞娜" name="Waitress"></c>
    <c id="芽衣" name="Innocent N00b"></c>
    <c id="符華" name="Challenger"></c>
    <c id="麗塔" name="Maid"></c>
    <c id="德麗莎" name="Cute Lil' Girl"></c>
    <c id="合金布狼牙" name="Alloy Bron"></c>
    <c id="大家" name="Everyone"></c>
  </characters>
</data>`
};